module.exports = "<button class=\"mat-raised-button\"  (click)=\"select()\" style=\"line-height:24px; height:24px; margin-left:5px;margin-top:3px; background-color:rgb(218, 233, 245)\">{{name}}</button>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fsapplication/preset/preset.component.html
// module id = ./src/app/fsapplication/preset/preset.component.html
// module chunks = main